import { render } from "./ord-container.vue?vue&type=template&id=9d74d1aa"
import script from "./ord-container.vue?vue&type=script&lang=js"
export * from "./ord-container.vue?vue&type=script&lang=js"

import "./ord-container.vue?vue&type=style&index=0&id=9d74d1aa&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__